<template>
  <v-container>
    <loading-spinner v-if="loading"> </loading-spinner>
    <v-row v-else>
      <v-col cols="12" v-for="(item, i) in sorted_signoff_ready" :key="i">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="auto">
                <user-avatar
                  :size="75"
                  :user="item.user"
                  borderColor="performance"
                  color="performance"
                  cssClass="mx-4 text-h4"
                  textColor="white"
                ></user-avatar>
              </v-col>
              <v-col>
                <div class="text-h6 secondarytext--text mb-3">
                  <template v-if="item.user.id == profile.id">
                    Your annual review is now available for you to sign off.
                  </template>
                  <template v-else>
                    Your annual review of
                    <strong>{{ item.user.fullName }}</strong> is now available
                    for sign off.
                  </template>
                </div>
                <v-btn
                  outlined
                  color="performance"
                  :to="`/annual-reviews/${item.user.id}/${item.id}/signoff`"
                >
                  View & Sign Off
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewSignoffReadyQueue",
  props: {},
  components: {},
  data: () => ({ loading: false }),
  computed: {
    sorted_signoff_ready() {
      let self = this;
      return this._.sortBy(this.signoff_ready, function(o) {
        return o.user.id != self.profile.id;
      });
    },
    ...mapGetters({
      signoff_ready: "annualreview/signoff_ready",
      profile: "profile/profile"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("annualreview/getSignoffReady")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your annual reviews."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {}
};
</script>
